import {observable, computed, action, decorate } from 'mobx';

class InputStore {
  value = '';
  isShowHint = false;
  name = '';
  label = '';
  hint = null;
  type = 'input';
  values = [];
  required = false;
  pattern = '';
  isValid = null;

  store = null;
  id = null;

  constructor(store, obj) {
    this.store = store;
    this.id = Math.random(); //uuid.v4()
    if(obj) {
      this.name = obj.name || this.name;
      this.label = obj.label || this.label;
      this.hint = obj.hint || this.hint;
      this.type = obj.type || this.type;
      if (obj.value !== null && obj.value !== undefined) {
        this.value = obj.value;
      }
      this.values = obj.values || this.values;
      if (obj.required !== undefined) {
        this.required = obj.required;
      }
      this.pattern = obj.pattern || this.pattern;
      if (obj.isValid !== undefined) {
        this.isValid = obj.isValid;
      }
    }
    this.isValid = this.checkValid(this.value);
  }
  get getValue() {
    return this.value;
  }

  updateValue(value) {
    this.value = value;
    this.isValid = this.checkValid(value);
  };

  get isCorrect() {
    if(!this.validator) return true;
    const isCorrect = this.validator(this.value);
    return isCorrect;
  }

  checkValid(value) {
    const {required} = this;
    const patternStr = this.pattern;
    let isValid = null;
    if (patternStr) {
      const pattern = new RegExp(patternStr);
      isValid = pattern.test(this.value);
      if (!required && value === '') {
        isValid = true;
      }
    } else {
      if (required && value === '') {
        isValid = false;
      } else {
        isValid = true;
      }
    }
    return isValid;
  }

  get textValue() {
    if(Object.values(this.values).length) return this.values[this.value];
    return this.value;
  }

};

decorate(InputStore, {
  value: observable,
  isShowHint: observable,
  name: observable,
  label: observable,
  validator: observable,
  hint: observable,
  type: observable,
  values: observable,
  required: observable,
  isValid: observable,
  getValue: computed,
  isCorrect: computed,
  checkValid: action.bound,
  updateValue: action.bound,
});

export default InputStore;
